import {Field} from "../types/domain/field";
import {FieldCreateFormInputType} from "./fieldValidationUtils";
import {FIELD_INITIAL_VALUES} from "./constants";
import {CropCycle} from "../types/domain/cropCycle";
import {HasId} from "../types/hasId";
import dayjs from "dayjs";

export interface hasIdWithName extends HasId {
    id: number;
    name: string;
}

export const convertToHasIdWithName = (items: number[]): hasIdWithName[] => {
    return items.map((item) => ({
        id: item,
        name: item.toString(),
    }));
};

export const constructValues = (field: Field): FieldCreateFormInputType => {
    const priority = field.priority === 0 ? false : true;
    const item = {
        ...field,
        priority: priority,
        cropCycles:
            field.cropCycles?.map((cycle) => ({
                ...cycle,
                plantedDate: cycle.plantedDate ? dayjs(cycle.plantedDate) : null,
                estHarvestDate: cycle.estHarvestDate ? dayjs(cycle.estHarvestDate) : null,
                actHarvestDate: cycle.actHarvestDate ? dayjs(cycle.actHarvestDate) : null,
            })) || FIELD_INITIAL_VALUES.cropCycles,
        irrigationTypeId: field.irrigationTypeId,
    };
    return item;
};

export const getDefaultForNewCropCycle = (): CropCycle => {
    // We want to sent cropCycle to null, to make clear for the user they need to fill this attribute, when they planted a new crop.
    return {...FIELD_INITIAL_VALUES.cropCycles[0], cropId: null as unknown as string};
};
